<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1400px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create Job Grade Code
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Grade Code"
      text="Create Job Grade Code"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <span class="font-weight-bold pr-2">Job Grade Codes:</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    color="primary"
                    v-on="{ ...dialog, ...tooltip }"
                    @click="addRow"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <span>Add new row</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row
            v-for="(jobGrade,counter) in jobGrades"
            :key="counter"
          >
            <v-col class="mx-1">
              <v-autocomplete
                v-model="jobGrade.job_group_id"
                v-validate="'required'"
                :items="jobGroups"
                item-text="name"
                item-value="id"
                hide-selected
                hide-no-data
                outlined
                label="Job Group"
                :error-messages="errors.collect('job_group_id'+counter)"
                :name="'job_group_id' + counter"
                data-vv-as="job group"
              />
            </v-col>

            <v-col class="mx-1">
              <v-autocomplete
                v-model="jobGrade.job_category_id"
                v-validate="'required'"
                :items="jobCategories"
                outlined
                item-text="name"
                item-value="id"
                hide-selected
                hide-no-data
                label="Job Category"
                :error-messages="errors.collect('job_category_id'+counter)"
                :name="'job_category_id' + counter"
                data-vv-as="job category"
              />
            </v-col>

            <v-col class="mx-1">
              <v-autocomplete
                v-model="jobGrade.job_band_id"
                v-validate="'required'"
                :items="jobBands"
                outlined
                item-text="value"
                item-value="id"
                hide-selected
                hide-no-data
                label="Job Band/Grade"
                :error-messages="errors.collect('job_band_id'+counter)"
                :name="'job_band_id' + counter"
                data-vv-as="job band/grade"
              />
            </v-col>

            <v-col class="mx-1">
              <v-text-field
                :v-model="jobGrade.name = constructGradeName(jobGrade)"
                :value="constructGradeName(jobGrade)"
                disabled
                outlined
                label="Name"
              />
            </v-col>

            <v-col class="mx-1">
              <v-text-field
                v-model="jobGrade.salary_from"
                v-validate="'required|twoDecimalValue'"
                :error-messages="errors.collect('salary_from'+counter)"
                :name="'salary_from' + counter"
                data-vv-as="salary from"
                label="Salary From"
                type="number"
                outlined
                prefix="RM"
                :min="0"
                @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col class="mx-1">
              <v-text-field
                v-model="jobGrade.salary_to"
                v-validate="'required|twoDecimalValue'"
                :error-messages="errors.collect('salary_to'+counter)"
                :name="'salary_to' + counter"
                data-vv-as="salary to"
                label="Salary To"
                type="number"
                outlined
                prefix="RM"
                :min="0"
                @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col cols="1">
              <v-icon
                color="error"
                @click="deleteRow(counter)"
              >
                mdi-window-close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        jobGrades: [{ name: null, job_group_id: null, job_category_id: null, job_band_id: null, salary_from: 0, salary_to: 0 }],
        jobGroups: [],
        jobCategories: [],
        jobBands: [],
      }
    },

    watch: {
      dialog: function (value) {
        this.resetForm()

        if (value) {
          Promise.all([
            this.$api.jobGroups().list(),
            this.$api.jobCategories().list(),
            this.$api.jobBands().list(),
          ]).then(([jobGroups, jobCategories, jobBands]) => {
            this.jobGroups = jobGroups.data
            this.jobCategories = jobCategories.data
            this.jobBands = jobBands.data
          })
        } else {
  
        }
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: { 
      addRow () {
        this.jobGrades.push({ name: null, job_group_id: null, job_category_id: null, job_band_id: null, salary_from: 0, salary_to: 0 })
      },

      deleteRow (counter) {
        this.jobGrades.splice(counter, 1)
      },

      prepareFormData () {
        return {
          grades: this.jobGrades,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
                
            this.$api.jobGrades().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new job grade code' })

                  this.dialog = false               
                }
              })
              .catch((error) => {
                if (error.response.status === 409) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      constructGradeName (jobGrade) {
        if (!jobGrade.job_group_id && !jobGrade.job_category_id && !jobGrade.job_band_id) return ''

        let jobGroup = this.jobGroups.find(jobGroup => jobGroup.id === jobGrade.job_group_id)
        let jobCategory = this.jobCategories.find(jobCategory => jobCategory.id === jobGrade.job_category_id)
        let jobBand = this.jobBands.find(jobBand => jobBand.id === jobGrade.job_band_id)

        return this.getNameInitials((jobGroup || {}).name || '') + '-' +
          ((jobCategory || {}).name || '').charAt(0) + '-' + 
          ((jobBand || {}).value || '').toUpperCase()
      },

      resetForm () {
        this.$validator.reset()
        this.jobGrades = [{ name: null, job_group_id: null, job_category_id: null, job_band_id: null, salary_from: 0, salary_to: 0 }]
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
      
      getNameInitials (string) {
        return _.words(string).reduce((accumulator, currentValue) => {
          accumulator += currentValue.charAt(0).toUpperCase()
          
          return accumulator
        }, '')
      },
    },
  }
</script>
